import axios from 'axios'
import {
  addI18nHeader,
  injectFormDataFormat,
  loginCheck,
  codeCheck,
  returnAllData,
} from './interceptors'

/*
【pureRequest】无默认请求头，无i18n，无登录校验，返回全部数据
  用于跨域请求等
 */
const pureRequest = axios.create()
// const pureRequest = axios.create({ withCredentials: true })
// pureRequest.interceptors.response.use(addI18nHeader) // todo
pureRequest.interceptors.response.use(returnAllData) // todo
// pureRequest.withCredentials = true


/*
  以下请求携带验签信息
 */
axios.defaults.withCredentials = true

/*
【commonRequest】json请求头常规【pureRequest】无默认请求头，无i18n,无登录校验，返回全部数据
 */
const commonRequest = axios.create({ withCredentials: true })
commonRequest.interceptors.request.use(addI18nHeader) // TODO:添加一些固有参数，不需要可删除
commonRequest.interceptors.response.use(loginCheck)
commonRequest.interceptors.response.use(codeCheck)

/*
【rqNoLoginCheck】
 */
const rqNoLoginCheck = axios.create({ withCredentials: true })
rqNoLoginCheck.interceptors.request.use(addI18nHeader) // TODO:添加一些固有参数，不需要可删除
rqNoLoginCheck.interceptors.response.use(codeCheck)

/*
【rqAllNoLoginCheck】
 */

const rqAllNoLoginCheck = axios.create({ withCredentials: true })
rqAllNoLoginCheck.interceptors.request.use(addI18nHeader) // TODO:添加一些固有参数，不需要可删除
rqAllNoLoginCheck.interceptors.response.use(returnAllData)

/*
【commonRequestAll】json请求头，数据全返回
 */
const commonRequestAll = axios.create()
commonRequestAll.interceptors.request.use(addI18nHeader) // TODO:添加一些固有参数，不需要可删除
commonRequestAll.interceptors.response.use(loginCheck)
commonRequestAll.interceptors.response.use(returnAllData)

//
/*
【commonFormRequest】form-urlEncode请求头常规
 */
const commonFormRequest = axios.create({
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
})
commonFormRequest.interceptors.request.use(injectFormDataFormat) // TODO:form-data请求
commonFormRequest.interceptors.request.use(addI18nHeader) // TODO:添加一些固有参数，不需要可删除
commonFormRequest.interceptors.response.use(loginCheck)
commonFormRequest.interceptors.response.use(codeCheck)

/*
【formRequestAllData】form-urlEncode请求头全返回
 */
const formRequestAllData = axios.create({
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
})
formRequestAllData.interceptors.request.use(injectFormDataFormat) // TODO:form-data请求
formRequestAllData.interceptors.request.use(addI18nHeader) // TODO:添加一些固有参数，不需要可删除
formRequestAllData.interceptors.response.use(loginCheck)
formRequestAllData.interceptors.response.use(returnAllData)

export { pureRequest, commonRequest, commonRequestAll, commonFormRequest, formRequestAllData, rqNoLoginCheck, rqAllNoLoginCheck }
